import { NonIdealState, Spinner } from '@blueprintjs/core'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

import { RouteGuardProps } from 'modules/router'
import { DispatchProp } from 'modules/store'

import { RouteLocationState } from '../../../types'

import { links } from '../../app.links'
import { State } from '../../store'

import { User } from '../models'
import { getIsLoggingIn, getLoggedIn, getUser } from '../store'
import * as fromAuth from '../store/auth.actions'

const mapStateToProps = (state: State) => ({
  isLoggedIn: getLoggedIn(state),
  isLoggingIn: getIsLoggingIn(state),
  user: getUser(state),
})

const enhance = connect(mapStateToProps)

export type Props = OwnProps & InjectedProps

type OwnProps = {}
type InjectedProps = {
  isLoggedIn: boolean
  isLoggingIn: boolean
  user: User
} & DispatchProp &
  RouteGuardProps

export class Auth extends Component<Props> {
  render() {
    const { isLoggedIn, isLoggingIn, location } = this.props

    if (isLoggingIn) {
      return (
        <NonIdealState title="Please wait...">
          <Spinner />
        </NonIdealState>
      )
    }

    if (!isLoggingIn && !isLoggedIn) {
      const routerState: RouteLocationState = { from: location }

      return (
        <Redirect
          to={{
            pathname: links.auth.home(),
            state: routerState,
          }}
        />
      )
    }

    return isLoggedIn && this.props.children
  }
  componentDidMount() {
    const { dispatch, isLoggedIn } = this.props
    !isLoggedIn && dispatch(new fromAuth.CurentUserAction())
  }
}

export default enhance(Auth)



// WEBPACK FOOTER //
// ./src/app/auth/components/auth.tsx